import MessageCard from '../../../../components/card/message-card';
import { RentalExtensionRequest } from '../../../../services/entities/requests/rental-extension-request';
import { RequestHandleType } from '../../../../shared/utility/enum-utility';
import ExtendRentalCtrls from '../component/extend-rental-ctrls';

function RetrieveRentalFrom(props) {
    const { formValue, setFormValue, errorMsg, disabled, onRetrieveReservation, closeModal } = props;
    const validateForm = () => {
        if (formValue?.firstName
            && formValue?.lastName
            && formValue?.email
            && formValue?.rentalAgreementNum) {
            return true
        }
        return false;
    }
    const onChange = (data, name) => {
        const tempData = { ...formValue };
        tempData[name] = data;
        setFormValue(tempData);
    }
    const getRentalOriginalDate = () => {
        const request = new RentalExtensionRequest({ rentalExtension: { ...formValue } });
        onRetrieveReservation(request, RequestHandleType.RESPONSE_ONLY, true)
    }

    return (
        <div className='extend-rental-div mb-3'>
            <div className='retreive-rental-form flex-column row-gap-1 justify-content-center' style={{ height: "350px" }}>
                {errorMsg ?
                    <MessageCard
                        contClasses="msg-error-block"
                        title={errorMsg?.messageType}
                        message={errorMsg?.displayMessage}
                        iconClass="fas fa-exclamation-triangle error-icon"
                    />
                    : ""
                }
                <ExtendRentalCtrls onChange={onChange} formValue={formValue} disabled={disabled} />
            </div>
            <hr />
            <div className='btn-container m-0'>
                <button className='btn btn-secondary' onClick={() => closeModal()}>Cancel</button>
                <button className='btn btn-outline-danger' onClick={() => setFormValue(null)}>Clear</button>
                <button className='btn btn-yellow-default' onClick={() => getRentalOriginalDate()} disabled={!validateForm()}>Retrieve</button>
            </div>
        </div>
    )
}

export default RetrieveRentalFrom